// Lucide icon by kebab-case name, matching the design system's <Icon name="..." />
// API. Icons are imported individually into an explicit registry so the bundle
// only carries the ones the portal actually uses (importing lucide's full `icons`
// record would pull the entire set — ~700 icons).
import {
  Activity,
  AlertTriangle,
  Archive,
  ArchiveRestore,
  ArrowLeft,
  ArrowRight,
  Bell,
  BookOpen,
  Calendar,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronsUpDown,
  CircleCheck,
  ClipboardCheck,
  Clock,
  Copy,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FilePenLine,
  FileText,
  Flag,
  Folder,
  FolderKanban,
  GitBranch,
  Hourglass,
  House,
  Image,
  Inbox,
  Kanban,
  KeyRound,
  Layers,
  LayoutDashboard,
  Link,
  List,
  ListChecks,
  Lock,
  LogOut,
  Mail,
  MessageSquare,
  NotebookPen,
  Paperclip,
  Pause,
  Pencil,
  Plus,
  RefreshCw,
  Reply,
  Rocket,
  RotateCcw,
  RotateCw,
  Search,
  Send,
  ShieldCheck,
  SquareCheck,
  Table,
  Trash2,
  TriangleAlert,
  Upload,
  User,
  UserCog,
  UserPlus,
  UserX,
  Users,
  X,
  Zap,
  type LucideIcon,
  type LucideProps,
} from "lucide-react";

const REGISTRY: Record<string, LucideIcon> = {
  activity: Activity,
  "alert-triangle": AlertTriangle,
  archive: Archive,
  "archive-restore": ArchiveRestore,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  bell: Bell,
  "book-open": BookOpen,
  calendar: Calendar,
  check: Check,
  "chevron-down": ChevronDown,
  "chevron-right": ChevronRight,
  "chevrons-up-down": ChevronsUpDown,
  "circle-check": CircleCheck,
  "clipboard-check": ClipboardCheck,
  clock: Clock,
  copy: Copy,
  download: Download,
  "external-link": ExternalLink,
  eye: Eye,
  "eye-off": EyeOff,
  file: File,
  "file-pen-line": FilePenLine,
  "file-text": FileText,
  flag: Flag,
  folder: Folder,
  "folder-kanban": FolderKanban,
  "git-branch": GitBranch,
  hourglass: Hourglass,
  house: House,
  image: Image,
  inbox: Inbox,
  kanban: Kanban,
  "key-round": KeyRound,
  layers: Layers,
  "layout-dashboard": LayoutDashboard,
  link: Link,
  list: List,
  "list-checks": ListChecks,
  lock: Lock,
  "log-out": LogOut,
  mail: Mail,
  "message-square": MessageSquare,
  "notebook-pen": NotebookPen,
  paperclip: Paperclip,
  pause: Pause,
  pencil: Pencil,
  plus: Plus,
  "refresh-cw": RefreshCw,
  reply: Reply,
  rocket: Rocket,
  "rotate-ccw": RotateCcw,
  "rotate-cw": RotateCw,
  search: Search,
  send: Send,
  "shield-check": ShieldCheck,
  "square-check": SquareCheck,
  table: Table,
  "trash-2": Trash2,
  "triangle-alert": TriangleAlert,
  upload: Upload,
  user: User,
  "user-cog": UserCog,
  "user-plus": UserPlus,
  "user-x": UserX,
  users: Users,
  x: X,
  zap: Zap,
};

export interface IconProps extends Omit<LucideProps, "ref"> {
  name: string;
  size?: number;
}

export function Icon({ name, size = 16, ...rest }: IconProps) {
  const Cmp = REGISTRY[name];
  if (!Cmp) return null;
  return <Cmp size={size} strokeWidth={2} aria-hidden {...rest} />;
}
